import LocaleService from "./services/LocaleService";

export const localeService = LocaleService;
